export const getShortDate = (dateObj) => {
    if (dateObj) {
        let options = {year: 'numeric', month: 'short'};
        return dateObj.toLocaleString("en-US", options);
    }
}

export const getFullDate = (dateObj) => {
    if (typeof dateObj === "string") dateObj = new Date(dateObj);
    if (isNaN(dateObj.getTime())) {
        return "N/A";
    }

    dateObj = new Date( dateObj.getTime() - dateObj.getTimezoneOffset() * -60000 );

    if (dateObj) {
        let options = {year: 'numeric', month: 'short', day: "numeric"};
        return dateObj.toLocaleString("en-US", options);
    }
}

export const calculateDiscountAmount = (amount, discount) => {
    let discountAmount = (amount * discount) / 100;
    return discountAmount.toFixed(2)
}

export const genericSorter = (a, b) => {
    if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b);
    } else if (typeof a === "number" && typeof b === "number") {
        return a - b;
    } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() - b.getTime();
    } else if (Array.isArray(a) && Array.isArray(b)) {
        for (let i = 0; i < a.length && i < b.length; i++) {
            const result = genericSorter(a[i], b[i]);
            if (result !== 0) {
                return result;
            }
        }
        return a.length - b.length;
    } else {
        return 0;
    }
}
